<div class="toolbar set-flex-res">
    <div class="title-side accent">
        <h3 class="toolbar-title">{{ 'PAGE.SETTING.TITLE' | translate }}</h3>
        <small class="set-font-size">{{ 'PAGE.SETTING.DESCRIPTION' | translate }}</small>
    </div>
    <!-- <app-order-category-group></app-order-category-group> -->
</div>
<div class="mg-divider">
    <mat-divider></mat-divider>
</div>
<!-- <div class="content" *ngIf="!self.email">
    <div class="email-invalid">
        <span class="title">{{'TITLE.ADD_EMAIL' | translate}}</span> <br>
        <span class="desc">{{'MSG.NO_EMAIL_DESC' | translate}}</span>
    </div>
</div> -->
<div class="content">
    <div id="settings">
        <div class="setting profile">
            <div>
                <div class="image">
                    <app-avatar [width]="100" [height]="100"></app-avatar>
                </div>
            </div>
            <div>
                <div class="action">
                    <input accept="image/*" type="file" hidden id="avatar-picker" (change)="onAvatarChange($event)">
                    <button type="button" mat-button class="file-picker">
                        <label for="avatar-picker"><mat-icon svgIcon="change"></mat-icon> {{ 'LABEL.CHANGE' | translate }}</label>
                    </button>
                </div>
            </div>
        </div>
        <p></p>
        <!-- <mat-divider></mat-divider>
        <div class="setting">
            <div>
                <div class="name">
                    <p><strong>{{ 'LABEL.NAME' | translate }}</strong></p>
                </div>
                <div class="value">
                    <p *ngIf="self.first_name || self.last_name, else emptyValue">{{ self.first_name }} {{self.last_name}}</p>
                </div>
            </div>
        </div>
        <mat-divider class="set-divider-width"></mat-divider>
        <div class="setting">
            <div>
                <div class="name">
                    <p><strong>{{ 'LABEL.GENDER' | translate }}</strong></p>
                </div>
                <div class="value">
                    <p *ngIf="self.gender, else emptyValue">{{ "GENDER." + self.gender | translate }}</p>
                </div>
            </div>
            <div class="set-action-btn-margin-top">
                <div class="action">
                    <button mat-button (click)="onChangeName()"><mat-icon svgIcon="edit"></mat-icon> {{ 'LABEL.CHANGE' | translate }}</button>
                </div>
            </div>
        </div> -->

        <mat-divider></mat-divider>
        <div class="setting">
            <div>
                <div class="name">
                    <p><strong>{{ 'LABEL.EMAIL' | translate }}</strong></p>
                </div>
                <div class="value">
                    <p *ngIf="self.email, else emptyValue">{{ self.email }}</p>
                </div>
            </div>
            <!-- <div *ngIf="!self?.email">
                <div class="action">
                    <button mat-button (click)="addEmail()"><mat-icon svgIcon="mail"></mat-icon> {{ 'LABEL.ADD_EMAIL' | translate }}</button>
                </div>
            </div> -->
        </div>
        <!-- change password -->
        <mat-divider></mat-divider>
        <div class="setting">
            <div>
                <div class="name">
                    <p><strong>{{ 'LABEL.PASSWORD' | translate }}</strong></p>
                </div>
                <div class="value">
                    <p>********</p>
                </div>
            </div>
            <div *ngIf="self?.verification_token != null">
                <div class="action">
                    <button mat-button (click)="onChangePassword()"><mat-icon svgIcon="change"></mat-icon> {{ 'LABEL.CHANGE' | translate }}</button>
                </div>
            </div>
        </div>

        <!-- change language -->
        <mat-divider></mat-divider>
        <div class="setting">
            <div>
                <div class="name">
                    <p><strong>{{ 'LANG.TITLE' | translate }}</strong></p>
                </div>
                <div class="value">
                    <img class="lang-image" with="20" height="20" src="./../../../../../assets/img/{{currentLang}}.svg" alt="not_found">
                    <span>{{ "LANG." + currentLang | translate }}</span>
                </div>
            </div>
            <div>
                <div class="action">
                    <button mat-button (click)="onChangeLanguage()"><mat-icon svgIcon="change"></mat-icon> {{ 'LABEL.CHANGE' | translate }}</button>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
    </div>
</div>

<ng-template #emptyValue>
    <p>{{'MSG.NO_EMAIL' | translate}}</p>
</ng-template>
